import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { useEntityRegistry } from '../../useEntityRegistry';
import { ANTD_GRAY } from '../../entity/shared/constants';
import { ChildGlossaryTermFragment } from '../../../graphql/glossaryNode.generated';
import { useGlossaryEntityData } from '../../entity/shared/GlossaryEntityContext';
import { AutoTooltip } from '../../entity/shared/components/common/AutoTooltip';

const TermWrapper = styled.div`
    font-weight: normal;
    margin-bottom: 4px;
`;

const nameStyles = `
    color: #4C4E54 !important;
    display: flex;
    align-items: center;
    padding: 4px;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    overflow: hidden;
`;

export const TermLink = styled(Link)<{ isSelected }>`
    ${nameStyles}

    ${(props) => props.isSelected && `background-color: #F3FAFD;`}

    span:not(.anticon) {
        overflow: hidden;
        display: inline-block;
        text-overflow: ellipsis;
    }

    &:hover {
        ${(props) => !props.isSelected && `background-color: #F3FAFD;`}
        color: #262626;
    }
`;

export const NameWrapper = styled.span<{ showSelectStyles?: boolean }>`
    ${nameStyles}

    &:hover {
        ${(props) =>
            props.showSelectStyles &&
            `
        background-color: ${ANTD_GRAY[3]};
        cursor: pointer;
        `}
    }
`;

interface Props {
    term: ChildGlossaryTermFragment;
    isSelecting?: boolean;
    selectTerm?: (urn: string, displayName: string) => void;
}

function TermItem(props: Props) {
    const { term, isSelecting, selectTerm } = props;

    const { entityData } = useGlossaryEntityData();
    const entityRegistry = useEntityRegistry();

    function handleSelectTerm() {
        if (selectTerm) {
            const displayName = entityRegistry.getDisplayName(term.type, term);
            selectTerm(term.urn, displayName);
        }
    }

    const isOnEntityPage = entityData && entityData.urn === term.urn;

    return (
        <TermWrapper>
            {!isSelecting && (
                <TermLink
                    to={`${entityRegistry.getEntityUrl(term.type, term.urn)}`}
                    isSelected={entityData?.urn === term.urn}
                >
                    <AutoTooltip>
                        {entityRegistry.getDisplayName(term.type, isOnEntityPage ? entityData : term)}
                    </AutoTooltip>
                </TermLink>
            )}
            {isSelecting && (
                <NameWrapper showSelectStyles={!!selectTerm} onClick={handleSelectTerm}>
                    {entityRegistry.getDisplayName(term.type, isOnEntityPage ? entityData : term)}
                </NameWrapper>
            )}
        </TermWrapper>
    );
}

export default TermItem;
